import React from "react"
import { connect } from "react-redux"
import { Loader2, FileQuestion } from "lucide-react"

/**
 * Loading component - Migrated to use lucide-react icons
 * Used for global loading and no data states
 * 
 * @param {boolean} isNoData - Show "No Data Found" message
 * @param {boolean} isLoader - Show loading spinner
 */
const Loading = (props) => {
  return (
    <div className="flex justify-center items-center py-8">
      {props.isNoData && (
        <div className="flex flex-col items-center justify-center py-8">
          <FileQuestion className="h-12 w-12 text-muted-foreground mb-4" />
          <div className="text-muted-foreground text-base">
            No Data Found
          </div>
        </div>
      )}
      {props.isLoader && (
        <div className="flex items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <span className="sr-only">Loading...</span>
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    totalRevenue: state.dashboard.totalRevenue,
  }
}

export default connect(mapStateToProps)(Loading)
